<template>
  <div class="section grid-view" style="padding: 10px 20px">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button no="delete" :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Payment.businessType')">
            <el-select v-model="editDialog.form.lob" no="lob">
              <el-option
                v-for="(item,index) in lobSource"
                :key="index"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Port')">
            <cargo-advance-select
              no="port"
              :select-type="selectTypeNames.basic_data_Seaport"
              :cache="false"
              filterable
              :callback-params="{key:'port'}"
              callback-method-type="value"
              :default-value="editDialog.form.port"
              :static-options="seaPortList"
              style="width:185px;"
              @parentCallBack="selectCargoItem"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getSeaPortList } from '@/api/seaport'
import { getOverseaAgentPortList } from '@/api/partner/overseaAgentPort'

export default {
  name: 'OverseaAgentForm',
  components: { cargoAdvanceSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedRow: null,
      lobSource: [],
      lobMap: new Map(),
      seaPortList: [],
      companyUuid: '',
      selectTypeNames: TYPE_NAMES,
      filter: {
        agentUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: p => { this.selectedRow = p.data }
      },
      columnDefs: [
        {
          headerName: this.$t('Payment.businessType'),
          field: 'lob',
          width: 200,
          valueFormatter: params => {
            return this.lobMap.get(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Port'),
          field: 'port',
          width: 200
        }
      ],
      rowData: [],
      deletedOverseaAgentPortKeys: [],
      editDialog: {
        visible: false,
        title: '',
        form: {}
      },
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    }
  },
  created() {
    const lobSource = this.$constantI18n('lobSource').filter(p => p.value !== 'RE')
    this.lobSource = [...lobSource]
    for (const item of this.lobSource) {
      this.lobMap.set(item.value, item.name)
    }
    getSeaPortList({ pageNum: 1, pageSize: 1000000 }).then(res => {
      this.seaPortList = res.data.list
    })
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.companyUuid = row.uuid
        const agentUuid = row.overseaAgentDetail.uuid
        if (agentUuid) {
          this.filter.agentUuid = agentUuid
          this.toQuery()
        } else {
          this.rowData = []
        }
        this.deletedOverseaAgentPortKeys = []
      }
    },
    toQuery() {
      const filter = this.filter
      getOverseaAgentPortList(filter).then(res => {
        res.data.list.forEach(p => {
          p.lobStr = this.lobMap.get(p.lob)
        })
        this.rowData = res.data.list
      })
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (!this.companyUuid || !this.filter.agentUuid) {
          this.$message.warning(this.$t('Partners.destinationOperationAgentNotMaintained'))
          return
        }
        this.editDialog.form = {
          uuid: '',
          lob: '',
          agentUuid: this.filter.agentUuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const rows = this.selectedRow ? [this.selectedRow] : []
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    selectCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    getSubmitData() {
      return {
        overseaAgentPorts: this.rowData,
        deletedOverseaAgentPortKeys: this.deletedOverseaAgentPortKeys
      }
    },
    saveSub() {
      const self = this
      const form = self.editDialog.form
      if (!form.lob || !form.port) {
        this.$message.info(this.$t('Partners.completeInputItems'))
        return
      }
      const row = this.rowData.find(item => item.seq === form.seq)
      if (row) {
        Object.assign(row, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      self.editDialog.visible = false
    },
    remove() {
      const self = this
      const rows = this.selectedRow ? [this.selectedRow] : []
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === rows[0].seq)
        this.rowData.splice(index, 1)
        if (rows[0].uuid) {
          this.deletedPortDestinationAgentKeys.push(rows[0].uuid)
        }
      }).catch(() => { })
    }
  }
}
</script>

<style>
</style>
